import { syncAction } from '@/lib/action';

export const erpSyncCompletedAction = syncAction('erpIntegration/ERP_SYNC_COMPLETED');
